const CLINICAL_HOSTS = [
  'localhost:8890',
  '127.0.0.1:8890',
  'clinical.color.com',
  'clinical.staging.color.com',
  'prod-clinical-web.monoweb.svc.cluster.local',
  'staging-clinical-web.monoweb.svc.cluster.local',
];

function isEphemeralClinical(hostName: string) {
  return hostName.startsWith('ephemeral-clinical-') && hostName.endsWith('.color.dev');
}

export function isClinicalHost() {
  return CLINICAL_HOSTS.includes(window.location.host) || isEphemeralClinical(window.location.host);
}
